import axios from '../../axios'

/*
 * 破格招录数据管理接口
 */

// 创建破格招录信息
export const createExceptions = data => {
    return axios({
        url: '/api/data/wish/exceptions',
        method: 'POST',
        data
    })
}

// 编辑破格招录信息
export const editExceptions = data => {
    return axios({
        url: '/api/data/wish/exceptions',
        method: 'PUT',
        data
    })
}

// 删除破格招录信息
export const deleteExceptions = data => {
    return axios({
        url: '/api/data/wish/exceptions',
        method: 'DELETE',
        data
    })
}

// 获取破格招录信息列表
export const getExceptionsList = data => {
    return axios({
        url: '/api/data/wish/exceptions',
        method: 'GET',
        data
    })
}

// 破格招录数据导出功能
export const exportExceptions = data => {
    return axios({
        url: '/api/data/wish/exceptions/export',
        method: 'POST',
        data
    })
}

// 破格招录数据导入功能
export const importExceptions = data => {
    return axios({
        url: '/api/data/wish/exceptions/import',
        method: 'POST',
        data
    })
}

// 破格招录数据批量更新功能
export const batchUpdateExceptions = data => {
    return axios({
        url: '/api/data/wish/exceptions/batch/update',
        method: 'POST',
        data
    })
}

// 破格招录数据批量删除功能
export const batchDeleteExceptions = data => {
    return axios({
        url: '/api/data/wish/exceptions/batch/delete',
        method: 'POST',
        data
    })
}

// 破格招录数据同步功能
export const syncExceptions = data => {
    return axios({
        url: '/api/data/wish/exceptions/sync',
        method: 'POST',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/dataManage/exceptions.js